import { render, staticRenderFns } from "./banner_projects.vue?vue&type=template&id=c9ac3fec&"
import script from "./banner_projects.vue?vue&type=script&lang=js&"
export * from "./banner_projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports